/** @file Sign-in: POST /auth/login, then re-read the session (actor + UI settings). */
import { throwError } from '@pose2d/format/throwError';
import type { ApiClient } from '../../api/createApiClient';
import { sessionStore } from '../../stores/sessionStore';
import { checkSession } from './checkSession';

/** Rejects with the server's Pose2DError (UNAUTHORIZED, RATE_LIMITED), or UNAUTHORIZED when the accepted login left no session. */
export async function signIn(client: Pick<ApiClient, 'login' | 'me' | 'getUiSettings'>, username: string, password: string): Promise<void> {
  await client.login(username, password);
  await checkSession(client);
  if (sessionStore.getState().status !== 'signedIn') {
    throwError('UNAUTHORIZED', undefined, { hint: 'the login was accepted but GET /auth/me found no session (cookie not stored?)' });
  }
}
